<a class="team rise-on-hover" [href]="homeTeamLink">
  <img [src]="homeTeamLogo" alt="Team Logo"/>
  <span>{{ matchDetailViewService.data.homeTeam.name }}</span>
</a>
<div class="match-info">
  <ng-container *ngIf="matchDetailViewService.data.match.isCurrentOrPast(); else date">
    <span class="status">{{ matchDetailViewService.getMinuteString() }}</span>
    <span class="score">{{ getScore() }}</span>
  </ng-container>
  <ng-template #date>
    <span class="date">{{ matchDetailViewService.data.match.date | date:'dd. MMMM' }}</span>
    <span class="time">{{ matchDetailViewService.data.match.date | date:'HH:mm' }}</span>
  </ng-template>
</div>
<a class="team rise-on-hover" [href]="awayTeamLink">
  <img [src]="awayTeamLogo" alt="Team Logo"/>
  <span>{{ matchDetailViewService.data.awayTeam.name }}</span>
</a>
